const TRUE = 'true';
const isEnabled = (value) => String(value).toLowerCase() === TRUE;

export const FEATURE = () => ({
  SHOW_LOGIN_PAGE: process.env.REACT_APP_SHOW_LOGIN_PAGE === TRUE,
  IS_SALESFORCE_CONFIGURED: process.env.REACT_APP_IS_SALESFORCE_CONFIGURED === TRUE,
  PATIENT_CHART_V2: process.env.REACT_APP_ENABLE_PATIENT_CHART_V2 === TRUE,
  PATIENT_CHART_V3: process.env.REACT_APP_ENABLE_PATIENT_CHART_V3 === TRUE,
  PAGE_HEADING: process.env.REACT_APP_ENABLE_PATIENT_CHART_PAGE_HEADING === TRUE,
  NAV_BAR: process.env.REACT_APP_ENABLE_PATIENT_CHART_NAV_BAR === TRUE,
  ORDER_HEADING: process.env.REACT_APP_ENABLE_PATIENT_CHART_ORDER_HEADING === TRUE,
  ACTIONS: process.env.REACT_APP_ENABLE_PATIENT_CHART_ACTIONS === TRUE,
  NEXT_ORDER: process.env.REACT_APP_ENABLE_PATIENT_NEXT_ORDER === TRUE,
  PATIENT_INFORMATION: process.env.REACT_APP_ENABLE_PATIENT_PATIENT_INFORMATION === TRUE,
  PRODUCTS: process.env.REACT_APP_ENABLE_PATIENT_PRODUCTS === TRUE,
  ADD_PRODUCT: process.env.REACT_APP_ENABLE_PATIENT_ADD_PRODUCT === TRUE,
  CHANGE_PRODUCT: process.env.REACT_APP_ENABLE_PATIENT_CHANGE_PRODUCT === TRUE,
  COMPLETE_VISIT: process.env.REACT_APP_ENABLE_COMPLETE_VISIT === TRUE,
  APPROVE: process.env.REACT_APP_ENABLE_APPROVE === TRUE,
  DOSESPOT_JUMP_START: process.env.REACT_APP_ENABLE_DOSESPOT_JUMP_START === TRUE,
  DENY_PRODUCT: process.env.REACT_APP_ENABLE_DENY_PRODUCT === TRUE,
  START_BUTTON: process.env.REACT_APP_ENABLE_START_BUTTON === TRUE,
  TABS: process.env.REACT_APP_ENABLE_TABS === TRUE,
  PULL_EMAIL_TEMPLATES_FROM_SALESFORCE: process.env.REACT_APP_PULL_EMAIL_TEMPLATES_FROM_SALESFORCE === TRUE,
  FLAGS: process.env.REACT_APP_ENABLE_FLAGS === TRUE,
  FLAGS_UPDATE: process.env.REACT_APP_FLAGS_UPDATE === TRUE,
  EXTENDED_CONSULT: process.env.REACT_APP_ENABLE_EXTENDED_CONSULT === TRUE,
  STOREFRONT_HISTORY: process.env.REACT_APP_ENABLE_STOREFRONT_HISTORY === TRUE,
  EMAILS_TAB: process.env.REACT_APP_ENABLE_EMAILS_TAB === TRUE,
  BENEFITS_TAB: isEnabled(process.env.REACT_APP_ENABLE_BENEFITS_TAB),
  MED_HISTORY: isEnabled(process.env.REACT_APP_ENABLE_MEDHISTORY_TAB),
  SHOW_CMN_FOR_AXENA: process.env.REACT_APP_SHOW_CMN_FOR_AXENA === TRUE,
  SHOW_CMN_FOR_BIONESS: process.env.REACT_APP_SHOW_CMN_FOR_BIONESS === TRUE,
  SHOW_CMN_FOR_DEXCOM: process.env.REACT_APP_SHOW_CMN_FOR_DEXCOM === TRUE,
  SHOW_CMN_FOR_APRETUDE: process.env.REACT_APP_SHOW_CMN_FOR_APRETUDE === TRUE,
  SHOW_CMN_FOR_VYEPTI: process.env.REACT_APP_SHOW_CMN_FOR_VYEPTI === TRUE,
  SHOW_CMN_FOR_TWIIST: process.env.REACT_APP_SHOW_CMN_FOR_TWIIST === TRUE,
  EVERSENSE_TEMPLATE_UPDATE: process.env.REACT_APP_EVERSENSE_TEMPLATE_UPDATE === TRUE,
  NOTES_TAB: process.env.REACT_APP_ENABLE_NOTES_TAB === TRUE,
  HISTORY_TAB: process.env.REACT_APP_ENABLE_HISTORY_TAB === TRUE,
  TASKS_TAB: process.env.REACT_APP_ENABLE_TASKS_TAB === TRUE,
  CHANGE_PASSWORD: process.env.REACT_APP_ENABLE_CHANGE_PASSWORD === TRUE,
  CHANGE_PIN: process.env.REACT_APP_ENABLE_CHANGE_PIN === TRUE,
  PROFILE: process.env.REACT_APP_ENABLE_PROFILE === TRUE,
  AVAILABILITY: process.env.REACT_APP_ENABLE_AVAILABILITY === TRUE,
  REPORTS: process.env.REACT_APP_ENABLE_REPORTS === TRUE,
  DOWNLOAD_CMN_PDF: process.env.REACT_APP_DOWNLOAD_CMN_PDF === TRUE,
  AUTO_RELOAD_VISITS: process.env.REACT_APP_ENABLE_AUTO_RELOAD_VISITS === TRUE,
  PATIENT_CHART_V1_VERSION_SELECTOR: process.env.REACT_APP_ENABLE_PATIENT_CHART_V1_VERSION_SELECTOR === TRUE,
  PATIENT_CHART_V2_VERSION_SELECTOR: process.env.REACT_APP_ENABLE_PATIENT_CHART_V2_VERSION_SELECTOR === TRUE,
  RICH_TEXT_EDITOR: process.env.REACT_APP_ENABLE_RICH_TEXT_EDITOR === TRUE,
  ICD10CODES: process.env.REACT_APP_ENABLE_ICD10CODES === TRUE,
  DOSESPOT_ACCESS: process.env.REACT_APP_ENABLE_DOSESPOT_ACCESS === TRUE,
  REPLACE_INPUT_BOXES_WITH_PARAGRAPHS: process.env.REACT_APP_REPLACE_INPUT_BOXES_WITH_PARAGRAPHS === TRUE,
  SCHEDULE: process.env.REACT_APP_ENABLE_SCHEDULE === TRUE,
  SHOW_TEXT_PATIENT_CHECKBOX_IN_SCHEDULE: process.env.REACT_APP_SHOW_TEXT_PATIENT_CHECKBOX_IN_SCHEDULE === TRUE,
});
